import React, { Component } from 'react';
import { Form } from 'react-final-form';
// import { FORM_ERROR } from 'final-form';
import { Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import JsonViewer from '../JsonViewer/JsonViewer';
import Logic from './../../Logic';
import Notification from '../Notification/Notification';
import WizardProgressBar from '../WizardProgressBar/WizardProgressBar';

class Wizard extends Component {

    static Page = ({ children }) => children;

    constructor(props) {
        super(props);
        this.state = { 
            page: props.initialValues.step, //0
            values: props.initialValues || {}
        };
    }

    componentDidMount(){
        if(this.props.initialValues.step > 0){
            this.props.notify(true, 'המערכת זיהת שבעבר התחלת למלא את הטופס, הינך הועברת לשלב שאליו הגעת');
            // this.openNotification(true, 'המערכת זיהת שבעבר התחלת למלא את הטופס, הינך הועברת לשלב שאליו הגעת');
        }
    }

    next = values => {
        const { children } = this.props;
        var validation = this.validate(values);
        if (Object.keys(validation).length > 0){
            console.log(validation);
            return;
        }

        this.setState(state => ({
            page: Math.min(state.page + 1, this.props.children.length - 1)
        }), () => { 
            this.props.onPageChange(this.state.page, React.Children.toArray(children).length); //this.state.page + 1
            // if(this.props.submitOnNext){
            //     this.handleSubmit(values); 
            // } 
        });
    }

    previous = () => {
        const { children } = this.props;
        this.setState(state => ({
            page: Math.max(state.page - 1, 0)
        }), () => this.props.onPageChange(this.state.page, React.Children.toArray(children).length)); //this.state.page + 1
    }

    //client validation
    validate = values => {
        const { children } = this.props;
        this.props.onPageChange(this.state.page + 1, React.Children.toArray(children).length); //used for isFillFormsByAdmin
        const activePage = React.Children.toArray(this.props.children)[this.state.page];
        return activePage.props.validate ? activePage.props.validate(values) : {};
    }
    
    arrayToObject = arr => {
        let res = {};
        for (let index = 0; index < arr.length; index++) {
            res[arr[index].Key] = arr[index].Value;
        }
        return res;
    }

    /*
    handleSubmit is the function which is called when used press next, it decide if to move to next step if there are no server validation errors.
    */
    handleSubmit = async values => {
        console.log('handling submit');
        const { children, onSubmit } = this.props;
        const { page } = this.state;
        const isLastPage = page === React.Children.toArray(children).length;
        const logic = new Logic();

        let res = await onSubmit(values, this.state.page); // + 1
        
        if(this.props.submitOnNext && !isLastPage){
            if(this.props.serverValidation){
                // return {[FORM_ERROR]: 'shit'}; //general error (here we use toasts instead)
                if(res.data.validation.length === 0 || Object.keys(res.data.validation).length === 0){
                    this.next(res.data.candidate); //if save was OK then pass the server provided object to the next step 
                }else{
                    return res.data.validation; 
                }
            }else{
                this.next(res.data.candidate);
            }
        }
        else if(isLastPage){
            if(this.props.serverValidation){
                if(Object.keys(res.data.data.validation).length === 0){
                    alert('השלמת את הבקשה לסיווג ביטחוני. תודה!');
                    //TODO: redirect to somewhere
                }else{
                    return res.data.validation;
                }
            }else{
                onSubmit(values, this.state.page + 1).then(res => {return res.data.candidate});
            }
        }else{ //next without submitting
            this.next(values);
        }
    }

    // openNotification(success, message){
    //     this.setState({ notificationSuccess:success, notificationMessage:message }, () => {
    //         setTimeout(() => {
    //             this.setState({notificationSuccess:false, notificationMessage: null });
    //         }, 5 * 1000);
    //     });
    // }

    render(){
        const { children } = this.props;
        const { page, values } = this.state;
        const activePage = React.Children.toArray(children)[page];
        const prevPage = page > 0 ? React.Children.toArray(children)[page - 1] : null;
        const nextPage = page < React.Children.toArray(children).length ? React.Children.toArray(children)[page + 1] : null;
        const isLastPage = page === React.Children.toArray(children).length - 1;
        
        const prevButtonCaption = prevPage && activePage.props.name && this.props.prevButtonPrefix && this.props.prevButtonPostfix ? 
                                    <>{this.props.prevButtonPrefix + prevPage.props.name + this.props.prevButtonPostfix }</> : 
                                    <><FontAwesome name="chevron-right"/> קודם</>;

        const nextButtonCaption = nextPage && activePage.props.name && this.props.prevButtonPrefix && this.props.prevButtonPostfix ? 
                                    <>{this.props.nextButtonPrefix + nextPage.props.name + this.props.nextButtonPostfix }</> :
                                    <>הבא <FontAwesome name="chevron-left"/></>;

        return (
        
            <Form initialValues={values} validate={this.validate} onSubmit={this.handleSubmit}>
            
            {({ submitError, handleSubmit, submitting, values }) =>
                <form onSubmit={handleSubmit}>
                    <WizardProgressBar step={page}/>
                    {activePage}
                    {submitError && <div className="text-danger">{submitError}</div>} {/* show submit error message */}
                    
                    {/* With captions for large screens */}
                    <div className="d-none d-md-block col-md-6 wizard-navigation-buttons mx-auto">
                        {(<Button disabled={page === 0} onClick={this.previous} color="secondary" className="float-right col-md-4">{prevButtonCaption}</Button>)}
                        {!isLastPage ? <Button type="submit" color="primary" className="float-left col-md-4">{nextButtonCaption}</Button> : null }
                    </div>

                    {/* without captions for mobile */}
                    <div className="d-block d-md-none col-xs-12 wizard-navigation-buttons mx-auto">
                        {(<Button disabled={page === 0} onClick={this.previous} color="secondary" className="float-right col-xs-4"><FontAwesome name="chevron-right"/> קודם</Button>)}
                        {!isLastPage ? <Button type="submit" color="primary" className="float-left col-xs-4">הבא <FontAwesome name="chevron-left"/></Button> : null }
                    </div>

                    <div style={{clear:'both'}}></div>
                    <JsonViewer init={this.props.init} data={values}/>
                    {/* <Notification success={this.state.notificationSuccess} message={this.state.notificationMessage}/> */}
                </form>
            }
            </Form>
        );
    }
  };
  
export default Wizard;